import { render, staticRenderFns } from "./PatientDetailsDialog.vue?vue&type=template&id=d8499dbe&scoped=true&"
import script from "./PatientDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./PatientDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PatientDetailsDialog.vue?vue&type=style&index=0&id=d8499dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8499dbe",
  null
  
)

export default component.exports